/* eslint react/default-props-match-prop-types:0 */
import React from 'react';
import PropTypes from 'prop-types';
import InputBoolean from '../internals/InputBoolean';

const SingleRadio = props => <InputBoolean type='radio' {...props} />;

SingleRadio.defaultProps = {
  variant: 'regular'
};

SingleRadio.propTypes = {
  className: PropTypes.string,
  ...InputBoolean.propTypes
};

export default SingleRadio;
